import { render } from "./User.vue?vue&type=template&id=b06f4240"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"
script.render = render

export default script